export const setMfaOptions = (options) => {
  return {
    type: "MFA_SET_OPTIONS",
    options,
  };
};

export const setMfaRequired = (required) => {
  return {
    type: "MFA_SET_REQUIRED",
    required,
  };
};

export const callGetMfaOptions = () => {
  return {
    type: "MFA_GET_OPTIONS",
  };
};

export const callSubmitMfaPreference = (method, id, callback) => {
  return {
    type: "MFA_SUBMIT_PREFERENCE",
    method,
    id,
    callback,
  };
};

export const callConfirmMfaCode = (code, callback) => {
  return {
    type: "MFA_SUBMIT_CODE",
    code,
    callback,
  };
};

export const callSubmitTravelExemption = (exemptionDto, callback) => {
  return {
    type: "SUBMIT_TRAVEL_EXEMPTION",
    exemptionDto,
    callback,
  };
};

export const clearMfa = () => {
  return {
    type: "CLEAR_MFA",
  };
};

export const mfaMaxAttempts = () => {
  return { type: "MFA_REACHED_MAX"};
};


// WEBPACK FOOTER //
// ./src/actions/mfa.actions.js